<template>
  <a-form class="form" layout="vertical" :model="formState">
    <a-form-item>
      <a-input
        v-model:value="formState.search"
        placeholder="Buscar por nombre de usuario"
        style="width: 220px"
      >
        <template #suffix>
          <SearchOutlined />
        </template>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.status"
        class="input"
        :options="[...usersStateOptions]"
        placeholder="Todos los estados del usuario"
      />
    </a-form-item>
  </a-form>
  <a-table
    size="middle"
    :scroll="scrollStyle"
    :loading="loading"
    :columns="slotsTableColumns"
    :dataSource="tableData?.results"
    :pagination="pagination"
    @change="handleTableChange"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'user'">
        <a-tag v-if="record.user !== null" color="blue">Slot Utilizado</a-tag>
        <a-tag v-else color="green"> Slot Disponible </a-tag>
      </template>
      <template v-if="column.dataIndex === 'deleteSlot'">
        <a-tooltip title="Eliminar Slot" v-if="record?.user_data?.role != 'Owner'">
          <DeleteOutlined @click="showModal(record)" />
        </a-tooltip>
      </template>
      <template v-if="column.key === 'status'">
        <a-tag v-if="record?.user_data?.user_status === UserStatus.Activo" color="green">
          Activo
        </a-tag>
        <a-tag v-else-if="record?.user_data?.user_status === UserStatus.Inactivo" color="default">
          Inactivo
        </a-tag>
        <a-tag v-else-if="record?.user_data?.user_status === UserStatus.Pendiente" color="default">
          Pendiente
        </a-tag>
        <p v-else>-</p>
      </template>
      <template v-if="column.key === 'assign'">
        <p v-if="record?.user_data?.fullname">{{ record?.user_data?.fullname }}</p>
        <p v-else-if="record?.user_data?.email">{{ record?.user_data?.email }}</p>
        <p v-else class="user-assign">Sin usuario</p>
      </template>
    </template>
  </a-table>
  <DeleteSlotModal
    :open="show"
    :record="selectedRecord"
    @update:open="handleUpdateModal"
    :slots="slots"
    :fetchSlotsTableData="fetchSlotsTableData"
  />
</template>

<script setup>
import { ref, toRefs, reactive, onMounted, computed, watch } from "vue";
import _, { cloneDeep } from "lodash";

import { slotsTableColumns } from "@/app/settings/utils/columns";
import { UserStatus } from "@/@types/settings/slots";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import DeleteSlotModal from "@/app/settings/components/modals/DeleteSlotModal.vue";
import { TABLE_SLOTS_SIZE } from "@/app/shared/utils/constants";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons-vue";
import EventBus from "@/app/shared/utils/eventBus";

const manager = new SlotManager();
const tableData = ref(null);
const show = ref(false);

const props = defineProps({
  slots: Object,
  type: Number,
});
const { slots } = toRefs(props);

const { scrollStyle } = useScrollResize({ headerMargin: 520, width: 1200 });

const currentYear = () => {
  const year = new Date().getFullYear();
  return year;
};

const currentMonth = () => {
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  return month;
};

const formState = reactive({
  search: "",
  status: "",
  currentYear: currentYear(),
  currentMonth: currentMonth(),
});

const usersStateOptions = [
  {
    value: "",
    label: "Todos los estados del usuario",
  },
  {
    value: 1,
    label: "Activo",
  },
  {
    value: 2,
    label: "Inactivo",
  },
  {
    value: 4,
    label: "Pendiente",
  },
];

const loading = ref(false);
const currentTablePage = ref(1);

const selectedRecord = ref(null);

const showModal = (record) => {
  console.log(record, "record");
  selectedRecord.value = record;
  show.value = true;
};

const handleUpdateModal = (isOpen) => {
  if (!isOpen) {
    selectedRecord.value = null;
  }
  show.value = isOpen;
};
const pagination = computed(() => ({
  total: tableData.value?.count,
  current: currentTablePage.value,
  pageSize: TABLE_SLOTS_SIZE,
  showSizeChanger: false,
}));

const fetchSlotsTableData = async () => {
  loading.value = true;
  const filters = cloneDeep(formState);

  tableData.value = await manager.getListSlots({
    filters,
    page: currentTablePage.value,
    type: props.type,
  });

  loading.value = false;
};

EventBus.on("updateTable", () => {
  fetchSlotsTableData();
});

const handleTableChange = async (page) => {
  currentTablePage.value = page.current;
  await fetchSlotsTableData();
};

watch(
  formState,
  _.debounce(() => {
    currentTablePage.value = 1;
    fetchSlotsTableData();
  }, 500),
  () => tableData,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      fetchSlotsTableData();
    }
  },
  { deep: true }
);

onMounted(() => fetchSlotsTableData());

defineExpose({ fetchSlotsTableData, tableData });
</script>

<style lang="sass" scoped>
.ant-table-cell
  .anticon
      &-delete
        color: $blue-6
p
  margin: 0
.form
  display: flex
  gap: 12px
  margin-bottom: 12px
  .input
    min-width: 160px

:deep(.ant-form-item)
  margin: 0
.button
  padding: 0
  height: 22px
.user
  &-assign
    color: $gray-6
    font-weight: 400
</style>
